/* SLIDE UP */
Element.prototype.slideUp = function (duration = 500) {
    this.style.transitionProperty = 'height, margin, padding';
    this.style.transitionDuration = duration + 'ms';
    this.style.boxSizing = 'border-box';
    this.style.height = this.offsetHeight + 'px';
    this.offsetHeight;
    this.style.overflow = 'hidden';
    this.style.height = 0;
    this.style.paddingTop = 0;
    this.style.paddingBottom = 0;
    this.style.marginTop = 0;
    this.style.marginBottom = 0;
    setTimeout(() => {
        this.style.display = 'none';
        this.style.removeProperty('height');
        this.style.removeProperty('padding-top');
        this.style.removeProperty('padding-bottom');
        this.style.removeProperty('margin-top');
        this.style.removeProperty('margin-bottom');
        this.style.removeProperty('overflow');
        this.style.removeProperty('transition-duration');
        this.style.removeProperty('transition-property');
    }, duration);
}

/* SLIDE DOWN */
Element.prototype.slideDown = function (duration = 500) {

    this.style.removeProperty('display');
    let display = window.getComputedStyle(this).display;
    if (display === 'none') display = 'block';
    this.style.display = display;
    let height = this.offsetHeight;
    this.style.overflow = 'hidden';
    this.style.height = 0;
    this.style.paddingTop = 0;
    this.style.paddingBottom = 0;
    this.style.marginTop = 0;
    this.style.marginBottom = 0;
    this.offsetHeight;
    this.style.boxSizing = 'border-box';
    this.style.transitionProperty = "height, margin, padding";
    this.style.transitionDuration = duration + 'ms';
    this.style.height = height + 'px';
    this.style.removeProperty('padding-top');
    this.style.removeProperty('padding-bottom');
    this.style.removeProperty('margin-top');
    this.style.removeProperty('margin-bottom');
    setTimeout(() => {
        this.style.removeProperty('height');
        this.style.removeProperty('overflow');
        this.style.removeProperty('transition-duration');
        this.style.removeProperty('transition-property');
    }, duration);
}

Element.prototype.slideToggle = function (duration = 500) {
    if (window.getComputedStyle(this).display === 'none') {
        return this.slideDown(duration);
    } else {
        return this.slideUp(duration);
    }
}

Element.prototype.getChildrenOnFirstLevel = function (filterClass) {
    const result = []

    let child = this.firstChild

    while (child) {
        if (child.nodeType === 1) {
            if (!filterClass) {
                result.push(child)
            } else if (child.classList.contains(filterClass)) {
                result.push(child)
            }
        }
        child = child.nextSibling
    }

    return result
}

Element.prototype.scrollToElement = function (duration = 500, offset = 0) {
    let targetPosition = this.getBoundingClientRect().top - offset
    let startPosition = window.pageYOffset
    let startTime = null

    const ease = function (t, b, c, d) {
        t /= d / 2
        if (t < 1) return (c / 2) * t * t + b
        t--
        return (-c / 2) * (t * (t - 2) - 1) + b
    }

    const animation = function (currentTime) {
        if (startTime === null) startTime = currentTime
        const timeElapsed = currentTime - startTime
        const run = ease(timeElapsed, startPosition, targetPosition, duration)
        window.scrollTo(0, run)
        if (timeElapsed < duration) requestAnimationFrame(animation)
    }
    requestAnimationFrame(animation)
}